import { FormFieldWidget, FormView, FormWidget, ModelFieldType, SPI, ViewType, Widget } from '@kunlun/dependencies';
import DealerCreditProfileTabs from './DealerCreditProfileTabs.vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.Integer,
    widget: 'DealerCreditProfileTab',
    multi: false
  })
)
export class FormStringDealerCreditProfileTabsFieldWidget extends FormFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(DealerCreditProfileTabs);
    return this;
  }

  // 获取当前页面所有的按钮
  @Widget.Reactive()
  public get currentViewActions() {
    return this.metadataRuntimeContext.model.modelActions || [];
  }

  @Widget.Method()
  async setFormLoading() {
    const formView = Widget.select(this.rootHandle!) as FormView;
    const formWidget = formView.getChildren()[1] as FormWidget;
    const fackLoading = () =>
      new Promise((resolve) => {
        setTimeout(() => {
          resolve(true);
        }, 1000);
      });
    await formWidget.load(fackLoading);
  }
}
